module.exports = __webpack_public_path__ + "static/media/bell-hover.17ca7de8.svg";